import { useMutation } from '@tanstack/react-query';

import { addAutoshipSubscription } from './addAutoshipSubscription';
import type { AddSubscriptionResponse, PostOrdergrooveAddSubscription } from './types';

type UseAddAutoshipSubscriptionParams = {
    onError?: (error: Error) => void;
    onSuccess?: (response: AddSubscriptionResponse, variables: PostOrdergrooveAddSubscription) => void;
};

/**
 * Adds an item to the customer's next Autoship order through OrderGroove.
 * Does not report to Sentry: callers log under their own key through `onError`.
 */
export function useAddAutoshipSubscription({ onError, onSuccess }: UseAddAutoshipSubscriptionParams = {}) {
    return useMutation({
        mutationFn: async (data: PostOrdergrooveAddSubscription) => {
            const response = await addAutoshipSubscription(data);

            if (!response) {
                throw new Error('No response from ordergroove subscription API');
            }

            return response;
        },
        onSuccess: (response, variables) => {
            onSuccess?.(response, variables);
        },
        onError: error => {
            onError?.(error);
        },
    });
}
